"use client";
import { sendEvent } from "@/lib/utils/analytics";
import { getCookie } from "@/lib/utils/common/common";
import { getExperimentVariant } from "@/lib/quiz-attribution";
import { QUIZ_VARIANT_TEST_A, QUIZ_VARIANT_TEST_B } from "@/lib/utils/common/constants";
import { useEffect } from "react";

export const PageLoadedEvent = ({
  event,
  variantServed,
}: {
  event: string;
  variantServed?: string | null;
}) => {
  useEffect(() => {
    const cfRegion = getCookie("_cfrg");
    const variant = getExperimentVariant();
    let pageType: string;
    if (variantServed === "video_exp") {
      pageType = "sp_website_only_video_exp";
    } else if (variantServed === "video_ab_exp") {
      pageType = "sp_website_only_video_ab_exp";
    } else if (variantServed === "video_ab_control") {
      pageType = "sp_website_only_video_ab_control";
    } else if (variantServed === "exp") {
      pageType = "sp_website_only_exp1";
    } else if (variant === QUIZ_VARIANT_TEST_A) {
      pageType = "website_quiz_integration_v1";
    } else if (variant === QUIZ_VARIANT_TEST_B) {
      pageType = "website_quiz_integration_v2";
    } else {
      pageType = "sp_website_only";
    }

    const props: Record<string, string> = { page_type: pageType };
    if (cfRegion) props.cf_region = cfRegion;
    if (variantServed) props.variant_served = variantServed;
    sendEvent(event, props);
  }, [event, variantServed]);
  return null;
};
